enum Routes {
  Authentication = "auth",
  ForgotPassword = "forgot-password",
  PasswordUpdate = "update-password",
  Register = "register",
  AuthNavigator = "auth-navigation",
  AppNavigator = "main",
  Explore = "explore",
  ExploreNavigator = "explore-navigator",
  RequestHistory = "request-history",
  RequestHistoryNavigator = "request-history-navigator",
  RequestHistoryDetail = "request-history-detail",
  RequestHistoryChildDetail = "request-history-child-detail",
  Favorites = "favorites",
  MoreNavigator = "more",
  More = "more-list",
  Splash = "splash",
  DocumentUpload = "upload-documents",
  ApplicationStatus = "application-status",
  Onboarding = "onboarding",
  OnboardingWeb = "onboarding-web",
  TermsAndConditions = "terms-and-conditions",
  HomeScreen = "home",
  ExternalHomeScreen = "external-home",
  ChangePriceMode = "change-price-mode",
  Logout = "logout",
  SearchResultScreen = "search-result-screen",
  FilterScreen = "filter-screen",
  FilterSearchScreen = "filter-search-screen",
  DefaultSearchGroup = "default-search-group",
  ProductSearchGroupScreen = "product-search-group",
  DeleteAccount = "delete-account",
  Languages = "languages",
  SearchText = "text-search",
  TermsOfUse = "terms-of-use",
  BiometricAuthorization = "biometric-authorization",
  Search = "search",
  ChooseAcategory = "choose-category",
  ChooseARequestScreen = "choose-request",
  Currency = "currency",
  FavoritesNavigator = "favorite-navigator",
  FavoritesListScreen = "favorites-list-screen",
  RequestDetailScreen = "request-detail",
  RequestModifyScreen = "request-modify",
  HomeNavigator = "home-navigator",
  PDPScreen = "pdp-screen",
  InternalPagesScreen = "internal-pages-screen",
  FindMatchScreen = "find-match-screen",
  SelectCollectionScreen = "select-collection-screen",
  SearchGroupNavigator = "search-group-navigator",
  GlobalNavigator = "global-navigator",
  PostOnBoardingScreen = "post-on-boarding-screen",
  FilterSplitScreen = "split-filter-screen",
  TermsOfUseScreen = "TermsOfUseScreen",
  CoachOverlayScreen = "coach-overlay-screen",
  BulkRequestNavigator = "bulk-request-navigator",
  BulkRequestScreen = "bulk-request-screen",
  BulkInitScreen = "bulk-init-screen",
  VerifiedScreen = "verified-screen",
  SavedSearch = "saved-searches",
  OrderCartScreen = "order-cart-screen",
  DropDownSearchScreen = "dropdown-search-screen",
  ReviewPage = "review-page",
  PagesNavigator = "pages-navigator",
  PagesScreen = "pages",
  CollectionsScreen = "collections-screen",
  AccountOverviewScreen = "account-overview-screen",
  AccountOverviewOverview = "account-overview-overview",
  AccountOverviewCompanyDetails = "account-overview-company-details",
  AccountOverviewUsersSeats = "account-overview-users-seats",
  AccountOverviewSecurity = "account-overview-security",
  BarcodeScannerScreen = "barcode-scanner-screen",
  AIChatBotScreen = "ai-chatbot-screen",
  OrderNowJewelryVariationScreen = "order-now-jewelry-variation-screen",
}

export default Routes;
